import React from 'react';
import { AnalyticsStatsCards } from './AnalyticsStatsCards';
import { AnalyticsCharts } from './AnalyticsCharts';
import { AnalyticsTables } from './AnalyticsTables';
import { AnalyticsWidgets } from './AnalyticsWidgets';
import { AnalyticsAdditionalCards } from './AnalyticsAdditionalCards';

const WebsiteAnalyticsDashboard: React.FC = () => {
  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-fluid">
          {/* Stats Cards */}
          <div className="mb-8">
            <AnalyticsStatsCards />
          </div>

          {/* Main Content Grid */}
          <div className="mb-8">
            <div className="row g-4">
              {/* Left Column - Charts */}
              <div className="col-xl-8 col-xxl-9">
                <AnalyticsCharts />
              </div>
              
              {/* Right Column - Activity & Quick Actions */}
              <div className="col-xl-4 col-xxl-3">
                <AnalyticsWidgets />
              </div>
            </div>
          </div>

          {/* Tables Section */}
          <div className="mb-8">
            <AnalyticsTables />
          </div>

          {/* Additional Cards Section */}
          <div className="mb-8">
            <AnalyticsAdditionalCards />
          </div>
        </div>
      </div>
    </div>
  );
};

export { WebsiteAnalyticsDashboard };
